import { useState, useCallback } from 'react';

const useConfirmDialog = () => {
  const [dialogState, setDialogState] = useState({
    isVisible: false,
    title: 'Confirm Action',
    message: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    confirmVariant: 'danger',
    size: 'md',
    onConfirm: null,
    onCancel: null
  });

  const showConfirm = useCallback((options) => {
    return new Promise((resolve) => {
      setDialogState({
        isVisible: true,
        title: options.title || 'Confirm Action',
        message: options.message || '',
        confirmText: options.confirmText || 'Confirm',
        cancelText: options.cancelText || 'Cancel',
        confirmVariant: options.confirmVariant || 'danger',
        size: options.size || 'md',
        onConfirm: () => {
          setDialogState(prev => ({ ...prev, isVisible: false }));
          resolve(true);
        },
        onCancel: () => {
          setDialogState(prev => ({ ...prev, isVisible: false }));
          resolve(false);
        }
      });
    });
  }, []);

  const hideDialog = useCallback(() => {
    setDialogState(prev => ({ ...prev, isVisible: false }));
  }, []);

  return {
    dialogState,
    showConfirm,
    hideDialog
  };
};

export default useConfirmDialog;